import jsPDF from 'jspdf';
import { uiText } from '@/i18n/interface';

let fontFiles: Promise<string[]> | undefined;
const fontName = 'NotoSans';
const encodeFont = (buffer: ArrayBuffer) => {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let index = 0; index < bytes.length; index += 8192) binary += String.fromCharCode(...bytes.subarray(index, index + 8192));
  return btoa(binary);
};

/** Fonts are served with the app, not fetched from an external font service. */
export const addGreekFontSupport = async (pdf: jsPDF) => {
  if (!fontFiles) {
    fontFiles = Promise.all(['Regular', 'Bold'].map(async style => {
      const response = await fetch(`/fonts/NotoSans-${style}.ttf`);
      if (!response.ok) throw new Error(uiText('Could not load the PDF font. Please try again.'));
      return encodeFont(await response.arrayBuffer());
    })).catch(error => { fontFiles = undefined; throw error; });
  }
  const files = await fontFiles;
  files.forEach((file, index) => {
    const filename = `NotoSans-${index === 0 ? 'Regular' : 'Bold'}.ttf`;
    pdf.addFileToVFS(filename, file);
    pdf.addFont(filename, fontName, index === 0 ? 'normal' : 'bold');
  });
  pdf.setFont(fontName, 'normal');
  pdf.setFontSize(12);
  return pdf;
};

export const addTextToPDF = (pdf: jsPDF, text: string, x: number, y: number, fontSize = 12, fontWeight = 'normal', maxWidth = 170): number => {
  if (!text) return y + fontSize * 0.35;
  pdf.setFont(fontName, fontWeight);
  pdf.setFontSize(fontSize);
  const lines = pdf.splitTextToSize(String(text), maxWidth);
  pdf.text(lines, x, y);
  return y + lines.length * fontSize * 0.4;
};

export const addTextLine = (pdf: jsPDF, label: string, value: string, x: number, y: number, fontSize = 12, maxWidth = 170) => addTextToPDF(pdf, `${label}: ${value}`, x, y, fontSize, 'normal', maxWidth);
export const getBilingualText = (englishText: string, currentLanguage: string): string => uiText(englishText, { lng: currentLanguage });
export const isGreekLanguage = (language?: string): boolean => language === 'el';
export const addBilingualTextLine = (pdf: jsPDF, label: string, value: string, x: number, y: number, language: string, fontSize = 12, maxWidth = 170) => addTextLine(pdf, getBilingualText(label, language), value, x, y, fontSize, maxWidth);
export const addBilingualHeader = (pdf: jsPDF, text: string, x: number, y: number, language: string, fontSize = 16) => addTextToPDF(pdf, getBilingualText(text, language), x, y, fontSize, 'bold');
export const addGreekTextToPDF = addTextToPDF;
export const addGreekTextLine = addTextLine;
export const processGreekTextForPDF = (text: string): string => text ? String(text) : '';
